import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

export const StyledReasonSelection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .reason-title {
    font-size: 32px;
    font-weight: 700;
    line-height: 1.2;
    color: ${COLOR.darkBlue};
    text-align: center;
    margin: 0 0 16px 0;
  }

  .reason-description {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: ${COLOR.label2[64]};
    text-align: center;
    margin: 0 0 40px 0;
  }

  .reasons-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 40px;
  }

  .reason-item {
    height: 48px;
    margin: 0;
    padding: 12px 16px;
    border: 0.5px solid ${COLOR.indigo[16]};
    border-radius: 12px;
    transition: border-color 0.15s ease;
    box-sizing: border-box;
    width: 100%;

    &:hover {
      border-color: ${COLOR.indigo[32]};
    }

    &.selected {
      border: 1px solid ${COLOR.darkBlue};
    }

    .MuiFormControlLabel-root {
      margin: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .MuiRadio-root {
      padding: 0;
      margin-right: 16px;
      flex-shrink: 0;
      color: ${COLOR.indigo[16]};

      &.Mui-checked {
        color: ${COLOR.darkBlue};
      }
    }

    .MuiFormControlLabel-label {
      font-size: 16px;
      font-weight: 500;
      color: ${COLOR.darkGray};
      line-height: 1.5;
      letter-spacing: -0.4px;
    }
  }

  .other-textarea-wrapper {
    margin-top: -8px;
    margin-bottom: 40px;

    .MuiOutlinedInput-root {
      border-radius: 12px;
    }
  }

  .cta-row {
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: 768px) {
    .reason-title {
      font-size: 24px;
    }

    .reasons-grid {
      grid-template-columns: 1fr;
    }

    .cta-row {
      justify-content: stretch;

      .MuiButtonBase-root {
        width: 100%;
      }
    }
  }
`;
